var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.157 5.087l2.985 9.809a.5.5 0 00.478.354h11.76a.5.5 0 00.478-.354l2.957-9.718a.5.5 0 00-.772-.55l-3.842 2.794a.5.5 0 01-.728-.157L11.184 1.51a.5.5 0 00-.868 0l-3.3 5.775a.5.5 0 01-.712.168L1.912 4.525a.5.5 0 00-.755.562z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCrown;